// 验证规则工具类

// 验证邮箱
export function checkEmail (rule, value, callback) {
  const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
  if (!value) {
    return callback(new Error('邮箱不能为空'))
  }
  setTimeout(() => {
    if (mailReg.test(value)) {
      callback()
    } else {
      callback(new Error('请输入正确的邮箱格式'))
    }
  }, 100)
}

// 验证用户密码
export function checkPassword (rule, value, callback) {
  const mailReg = /^[a-zA-Z0-9_]{6,18}$/
  if (!value) {
    return callback(new Error('密码不能为空'))
  }
  setTimeout(() => {
    if (mailReg.test(value)) {
      callback()
    } else {
      callback(new Error('长度在6到18个字符（字母、数字和下划线）'))
    }
  }, 100)
}

// 验证邮箱验证码
export function checkEmailCode (rule, value, callback) {
  const mailReg = /^[A-Za-z0-9]{6}$/
  if (!value) {
    return callback(new Error('邮箱验证码不能为空'))
  }
  setTimeout(() => {
    if (mailReg.test(value)) {
      callback()
    } else {
      callback(new Error('长度在6个字符（数字或字母）'))
    }
  }, 100)
}

// 验证产品名称
export function checkProductName (rule, value, callback) {
  const mailReg = /^[\u4E00-\u9FA5A-Za-z0-9]{1,16}$/
  if (!value) {
    return callback(new Error('产品名称不能为空'))
  }
  setTimeout(() => {
    if (mailReg.test(value)) {
      callback()
    } else {
      callback(new Error('长度在1~16之间，只能包含中文、字母、数字'))
    }
  }, 100)
}

// 验证产品描述
export function checkProductTip (rule, value, callback) {
  const mailReg = /^[\u4E00-\u9FA5A-Za-z0-9，,。.]{0,100}$/
  if (!value) {
    return callback()
  }
  setTimeout(() => {
    if (mailReg.test(value)) {
      callback()
    } else {
      callback(new Error('长度在0-100之间，只能包含中文、字母、数字、标点符号'))
    }
  }, 100)
}

export default {
  // 验证邮箱
  checkEmail: [{ required: true, validator: checkEmail, trigger: 'blur' }],
  // 验证密码
  checkPassword: [{ required: true, validator: checkPassword, trigger: 'blur' }],
  // 验证邮箱验证码
  checkEmailCode: [{ required: true, validator: checkEmailCode, trigger: 'blur' }],
  // 验证产品名称
  checkProductName: [{ required: true, validator: checkProductName, trigger: 'blur' }],
  // 验证产品描述
  checkProductTip: [{ required: false, validator: checkProductTip, trigger: 'blur' }]
}
